import { gql } from '@apollo/client';

export const fetchAvailablePricingPlans = gql`
  query fetchAvailablePricingPlans($id: String, $filterOptions: [FilterOption]) {
    entitlementDetails(id: $id) {
      id
      billingCycle
      plan
      availablePricingPlans(filterOptions: $filterOptions) {
        type
        billingFrequency
        id
        currency
        pricingPlanType
        status
        description
        offeringName
        tiers {
          unitAmount
          flatAmount
          floor
          ceiling
        }
        chargeElement
        chargeType
      }
    }
  }
`;
